import Highcharts from "highcharts";
import { useEffect } from "react";

import { OptionsBubbleSeries, OptionsScatterSeries } from "store/slice/charts/chartsSlice.types";

const useCustomiseLabels = (
    showRoles: boolean,
    showNames: boolean,
    setChartOptions:
        | React.Dispatch<React.SetStateAction<OptionsBubbleSeries>>
        | React.Dispatch<React.SetStateAction<OptionsScatterSeries>>,
    legendSelected: number[],
    showAllLabels?: boolean,
    hideAllLabels?: boolean,
    isSwitchAllLabelsEnabled?: boolean
): void => {
    useEffect(() => {
        //@ts-ignore
        setChartOptions((options: OptionsBubbleSeries | OptionsScatterSeries | Highcharts.Options) => {
            const { series, plotOptions, ...restOptions } = options;

            const updatedPlotOptions = { ...options.plotOptions };
            if (updatedPlotOptions?.series && updatedPlotOptions.series.dataLabels && isSwitchAllLabelsEnabled) {
                if (Array.isArray(updatedPlotOptions.series.dataLabels)) {
                    updatedPlotOptions.series.dataLabels.map((label) => (label.allowOverlap = showAllLabels));
                } else {
                    updatedPlotOptions.series.dataLabels.allowOverlap = showAllLabels;
                }
            }

            const newSeries = series
                ? //@ts-ignore
                  series.map(({ data, type, ...restSerieOptions }, index) => {
                      return {
                          ...restSerieOptions,
                          ...(options.chart && options.chart.className === "PotentialChart"
                              ? {
                                    name:
                                        showRoles && showNames
                                            ? `${data[0].custom?.entity_name ?? ""}</br>${data[0].custom?.label ?? ""}`
                                            : showRoles
                                            ? data[0].custom?.label ?? ""
                                            : showNames
                                            ? data[0].custom?.entity_name ?? ""
                                            : data[0].custom?.label ?? "",
                                }
                              : {}),

                          visible: legendSelected.includes(index) ? true : false,
                          data: data
                              ? data.map((option: Highcharts.PointOptionsObject) => {
                                    const { dataLabels, ...restPointOptions } = option;

                                    return {
                                        ...restPointOptions,
                                        dataLabels: {
                                            ...dataLabels,
                                            ...(options.chart && options.chart.className === "TeamCompetitiveChart"
                                                ? {
                                                      enabled: showNames,
                                                  }
                                                : {
                                                      enabled: hideAllLabels ? false : true,
                                                      format:
                                                          showRoles && showNames
                                                              ? restPointOptions.custom?.entity_type === "person"
                                                                  ? `${
                                                                        restPointOptions.custom?.entity_name ??
                                                                        restPointOptions.name
                                                                    } - ${restPointOptions.custom?.label ?? ""}`
                                                                  : `${restPointOptions.custom?.label}`
                                                              : showRoles
                                                              ? restPointOptions.custom?.label ?? ""
                                                              : showNames
                                                              ? restPointOptions.custom?.entity_type === "person"
                                                                  ? restPointOptions.custom?.entity_name ??
                                                                    restPointOptions.name
                                                                  : restPointOptions.custom?.label ?? ""
                                                              : "",
                                                  }),
                                        },
                                    };
                                })
                              : undefined,
                      };
                  })
                : undefined;

            return { ...restOptions, series: newSeries, plotOptions: updatedPlotOptions };
        });
    }, [showRoles, showNames, setChartOptions, legendSelected, showAllLabels, hideAllLabels, isSwitchAllLabelsEnabled]);
};

export default useCustomiseLabels;
